<template>
  <v-container fluid class="principal-container fill-height pa-0">
    <v-row align="center" justify="center" class="ma-0 w-100">
      <v-col cols="12" class="text-center mb-6">
        <h1 class="text-h3 font-weight-bold text-white mb-2">
          Seleccione el Proyecto
        </h1>
        <p class="text-subtitle-1 text-grey-lighten-1">
          Elija una sede para cargar la configuración correspondiente o cierre sesión
        </p>
      </v-col>

      <v-col cols="12" md="10" lg="10" xl="8">
        <v-row justify="center" align="stretch">
          <!-- Tarjetas de las Minas -->
          <v-col
            v-for="(project, index) in projects"
            :key="index"
            cols="12"
            sm="6"
            md="3"
          >
            <v-card
              class="project-card d-flex flex-column justify-center align-center pa-6 rounded-xl h-100"
              elevation="10"
              @click="seleccionarProyecto(project.key)"
            >
              <v-icon size="50" color="white" class="mb-4">
                {{ project.icon }}
              </v-icon>
              <h2 class="text-h5 font-weight-bold text-white text-center">
                {{ project.title }}
              </h2>
              <v-btn
                class="mt-6 font-weight-bold text-none rounded-lg"
                color="white"
                variant="flat"
              >
                Ingresar
              </v-btn>
            </v-card>
          </v-col>

          <!-- Tarjeta de Cerrar Sesión -->
          <v-col cols="12" sm="6" md="3">
            <v-card
              class="project-card logout-card d-flex flex-column justify-center align-center pa-6 rounded-xl h-100"
              elevation="10"
              @click="cerrarSesionDesarrollador"
            >
              <v-icon size="50" color="error" class="mb-4">
                mdi-logout
              </v-icon>
              <h2 class="text-h5 font-weight-bold text-white text-center">
                Cerrar Sesión
              </h2>
              <v-btn
                class="mt-6 font-weight-bold text-none rounded-lg"
                color="error"
                variant="flat"
              >
                Salir
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { MINAS_CONFIG, changeURL } from '@/constants/apis';
import { VISIBLE_PAGES } from '@/constants/labels';
import router from '@/router';
import { useStore } from 'vuex';
import { useTheme } from 'vuetify';

const store = useStore();
const theme = useTheme();

const projects = [
  { key: 'CANANEA', title: 'SmartLink Cananea', icon: 'mdi-domain' },
  { key: 'COLLAHUASI', title: 'SmartLink Collahuasi', icon: 'mdi-factory' },
  { key: 'NACOZARI', title: 'SmartLink Nacozari', icon: 'mdi-transmission-tower' },
  { key: 'TEPEACA', title: 'SmartLink Tepeaca', icon: 'mdi-truck-cargo-container' },
];

const seleccionarProyecto = (keyMina: string) => {
  const minaData = MINAS_CONFIG[keyMina as keyof typeof MINAS_CONFIG];

  if (minaData) {
    changeURL(minaData.index);
    store.commit('setProjectName', minaData.name);
    store.commit('setProjectLAT', minaData.lat);
    store.commit('setProjectLNG', minaData.lng);
    store.commit('setProjectZOOM', minaData.zoom);

    store.commit('setAppBarPage', 'smartlinkPage');

    minaData.index === 3 ? router.push(`/smartlink/cemex/${VISIBLE_PAGES.tepeaca.dashboard}`) : router.push(`/smartlink/${VISIBLE_PAGES.dashboard}`)
    ;
  }
};

const cerrarSesionDesarrollador = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("rol");
  store.commit("setUserSesion", null);
  // store.commit("setUserRol", null);

  store.commit('setAppBarPage', 'loginPage');
  router.push('/login');

  theme.change("darkCustom");
};
</script>

<style scoped>
.principal-container {
  background-color: #0b111e;
  background-image: radial-gradient(circle at 50% 50%, #1a2536 0%, #0b111e 100%);
  min-height: 100vh;
}

.project-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.project-card:hover {
  transform: translateY(-8px);
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
}

/* Estilo sutil diferencial para la tarjeta de salir */
.logout-card {
  border-color: rgba(255, 82, 82, 0.3);
}

.logout-card:hover {
  background: rgba(255, 82, 82, 0.15);
  border-color: rgba(255, 82, 82, 0.6);
}
</style>